<template lang="pug">
.game
  .game-over(v-if="isGameOver")
    .game-over-text
      p.typing-demo.game-over-typing(
        :style="{ color: winningTeam, width: gameOverText.length + 'ch', 'animation-timing-function': 'steps(' + (gameOverText.length + 10) + ')' }"
      ) {{ gameOverText }}
      p.typing-demo.type-play-again(@click='goToMain') Play Again
  .reveal(v-show="isRevealingCard")
    #reveal-card
      p {{ this.selectedCard.word }}
  .bg-overlay 
  .header
    .team-turn
      p(:style="{ color: currentTurn }") {{ displayTurn }}
  .main-container 
    .red-container
      .team-header
        p.typing-demo.type-red-team Red Team
      .team-member(
        v-for="(aPlayer, index) in redTeamPlayers",
        :key="'red-' + index"
      )
        p.typing-demo(
          :style="{ width: aPlayer.name.length + 'ch', 'animation-timing-function': 'steps(' + aPlayer.name.length + ')' }"
        ) {{ aPlayer.name }}
        span.you(v-if="aPlayer.id === player.id") (You)
        .spymaster(v-if="aPlayer.isSpyMaster")
          img(src="../assets/spymaster-2.svg")
      .vertical-pad
      .controls(
        v-show="currentTurn === 'red' && player.team === 'red'",
        @click="endTurn"
      )
        p Done
    .middle-container
      .board
        .cell(
          v-for="(card, index) in cards",
          :key="'card-' + index",
          @click="selectCard(card, index)",
          :id="'cell-' + index",
          :style="{ 'background-color': card.isRevealed || player.isSpyMaster ? cardColor(card) : 'rgba(0, 0, 0, 0.5)', color: (card.isRevealed || player.isSpyMaster) && card.type === 'neutral' ? '#000' : '#fff', border: card.isRevealed ? '1px solid #fff' : '' }",
          :class="{ clickable: player.team === currentTurn && !player.isSpyMaster && !card.isRevealed, animated: player.team === currentTurn && !player.isSpyMaster && !card.isRevealed, shine: player.isSpyMaster && card.isRevealed }"
        )
          p.typing-demo(
            :style="{ width: card.word.length + 'ch', 'animation-timing-function': 'steps(' + card.word.length + ')' }"
          ) {{ card.word }}
          .cover(v-if="player.isSpyMaster && !card.isRevealed") 

    .blue-container
      .team-header
        p.typing-demo.type-blue-team Blue Team
      .team-member(
        v-for="(aPlayer, index) in blueTeamPlayers",
        :key="'blue-' + index"
      )
        p.typing-demo(
          :style="{ width: aPlayer.name.length + 'ch', 'animation-timing-function': 'steps(' + aPlayer.name.length + ')' }"
        ) {{ aPlayer.name }}
        span.you(v-if="aPlayer.id === player.id") (You)
        .spymaster(v-if="aPlayer.isSpyMaster")
          img(src="../assets/spymaster-2.svg")
      .vertical-pad
      .controls(
        v-show="currentTurn === 'blue' && player.team === 'blue'",
        @click="endTurn"
      )
        p Done
</template>

<script>
// Hello
export default {
  name: "Game",
  data() {
    return {
      winningTeam: "Red",
      gameId: "",
      player: {},
      listeners: [],
      lobbyId: "",
      isGameOver: false,
      currentTurn: "",
      selectedCard: "",
      isRevealingCard: false,
      isRevealingAnimation: false,
      words: [
        {
          text: "Razor",
          color: "rgba(183, 13, 57, 1)",
          isRevealed: false,
        },
        {
          text: "Lion",
          color: "rgba(3, 43, 173, 1)",
          isRevealed: false,
        },
        {
          text: "Wonderland",
          color: "rgba(250, 248, 227, 1)",
          isRevealed: false,
        },
        {
          text: "Water",
          color: "rgba(3, 43, 173, 1)",
          isRevealed: false,
        },
        {
          text: "Microwave",
          color: "rgba(3, 43, 173, 1)",
          isRevealed: false,
        },
        {
          text: "Storm",
          color: "rgba(3, 43, 173, 1)",
          isRevealed: false,
        },
        {
          text: "Back",
          color: "rgba(250, 248, 227, 1)",
          isRevealed: false,
        },
        {
          text: "Track",
          color: "rgba(183, 13, 57, 1)",
          isRevealed: false,
        },
        {
          text: "Boil",
          color: "rgba(3, 43, 173, 1)",
          isRevealed: false,
        },
        {
          text: "Page",
          color: "rgba(250, 248, 227, 1)",
          isRevealed: false,
        },
        {
          text: "Pocket",
          color: "rgba(3, 43, 173, 1)",
          isRevealed: false,
        },
        {
          text: "Potato",
          color: "rgba(3, 43, 173, 1)",
          isRevealed: false,
        },
        {
          text: "Soldier",
          color: "rgba(250, 248, 227, 1)",
          isRevealed: false,
        },
        {
          text: "Ice Age",
          color: "rgba(183, 13, 57, 1)",
          isRevealed: false,
        },
        {
          text: "Mole",
          color: "rgba(183, 13, 57, 1)",
          isRevealed: false,
        },
        {
          text: "Letter",
          color: "rgba(183, 13, 57, 1)",
          isRevealed: false,
        },
        {
          text: "Leaf",
          color: "rgba(250, 248, 227, 1)",
          isRevealed: false,
        },
        {
          text: "Greenhouse",
          color: "rgba(183, 13, 57, 1)",
          isRevealed: false,
        },
        {
          text: "Santa",
          color: "rgba(250, 248, 227, 1)",
          isRevealed: false,
        },
        {
          text: "Spot",
          color: "rgba(183, 13, 57, 1)",
          isRevealed: false,
        },
        {
          text: "Berlin",
          color: "rgba(250, 248, 227, 1)",
          isRevealed: false,
        },
        {
          text: "Potter",
          color: "rgba(250, 248, 227, 1)",
          isRevealed: false,
        },
        {
          text: "Switch",
          color: "darkgrey",
          isRevealed: false,
        },
        {
          text: "Undertaker",
          color: "rgba(183, 13, 57, 1)",
          isRevealed: false,
        },
        {
          text: "Snake",
          color: "rgba(250, 248, 227, 1)",
          isRevealed: false,
        },
      ],
    };
  },
  watch: {
    cards(newVal, oldVal) {
      if (!newVal) return;
      const redCards = newVal.filter(
        (card) => card.isRevealed && card.type === "red"
      );
      const blueCards = newVal.filter(
        (card) => card.isRevealed && card.type === "blue"
      );
      const db = this.$store.state.db;
      const gameOverQuery =
        "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/isOver";
      const winningTeamQuery =
        "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/winningTeam";
      const updates = {};

      if (redCards.length >= 8) {
        updates[gameOverQuery] = true;
        updates[winningTeamQuery] = "red";
        db.ref().update(updates);
      } else if (blueCards.length >= 7) {
        updates[gameOverQuery] = true;
        updates[winningTeamQuery] = "blue";
        db.ref().update(updates);
      }
    },
  },
  computed: {
    gameOverText() {
      if (!this.winningTeam) {
        return "";
      }

      if (this.winningTeam.length === 0) {
        return "";
      }
      const team = this.winningTeam === "red" ? "Red" : "Blue";
      return team + " Team Wins";
    },
    displayTurn() {
      return this.currentTurn === "blue" ? "Blue's Turn" : "Red's Turn";
    },
    gamePlayers() {
      return this.$store.state.gamePlayers;
    },
    cards() {
      return this.$store.state.cards;
    },
    blueTeamPlayers() {
      return this.$store.state.gamePlayers.filter(
        (player) => player.team === "blue"
      );
    },
    redTeamPlayers() {
      return this.$store.state.gamePlayers.filter(
        (player) => player.team === "red"
      );
    },
  },
  methods: {
    goToMain() {
      this.disconnect()      
      for (let i = 0; i < this.listeners.length; i++) {
        const listenerObj = this.listeners[i];
        listenerObj.ref.off("value", listenerObj.listener);
      }
      this.$store.commit("resetState");
      this.$router.push("/");      
    },
    endTurn() {
      const nextTurn = this.currentTurn === "red" ? "blue" : "red";
      const db = this.$store.state.db;
      const query =
        "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/turn";
      const updates = {};
      updates[query] = nextTurn;
      db.ref().update(updates);
    },
    cardColor(card) {
      // eslint-disable-next-line
      if (this.player.isSpyMaster && false) {
        if (card.type === "neutral") {
          return card.isRevealed
            ? "rgba(250, 248, 227, 1)"
            : "rgba(173, 169, 128, 1)";
        } else if (card.type === "red") {
          return card.isRevealed
            ? "rgba(183, 13, 57, 1)"
            : "rgba(138, 63, 83, 1)";
        } else if (card.type === "blue") {
          return card.isRevealed
            ? "rgba(3, 43, 173, 1)"
            : "rgba(33, 53, 115, 1)";
        } else if (card.type === "assassin") {
          return card.isRevealed ? "darkgrey" : "black";
        }
      } else {
        if (card.type === "neutral") {
          return "rgba(250, 248, 227, 1)";
        } else if (card.type === "red") {
          return "rgba(183, 13, 57, 1)";
        } else if (card.type === "blue") {
          return "rgba(3, 43, 173, 1)";
        } else if (card.type === "assassin") {
          return "darkgrey";
        }
      }
    },
    triggerRevealAnimation(card, index) {
      const db = this.$store.state.db;
      const updates = {};
      const query =
        "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/revealing";
      const postData = {
        is: true,
        cardIndex: index,
        owner: this.player,
        card: card,
      };
      updates[query] = postData;
      db.ref().update(updates);
    },
    triggerEndRevealAnimation(card, index) {
      const db = this.$store.state.db;
      const updates = {};
      const query =
        "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/revealing";
      const postData = {
        is: false,
        cardIndex: index,
        owner: this.player,
        card: card,
      };
      updates[query] = postData;
      db.ref().update(updates);
    },
    triggerRevealCard(index) {
      const db = this.$store.state.db;
      const updates = {};
      const query =
        "/lobby/" +
        this.lobbyId +
        "/" +
        this.gameId +
        "/state/cards/" +
        index +
        "/isRevealed";
      updates[query] = true;
      db.ref().update(updates);
    },
    selectCard(card, index) {
      if (!this.player.isSpyMaster) {
        if (this.player.team === this.currentTurn) {
          if (!card.isRevealed) {
            this.triggerRevealAnimation(card, index);
          }
        }
      }
    },
    initDbListeners() {
      this.initGamePlayersListeners();
      this.initGameStateListener();
      this.initCardRevealListener();
    },
    initCardRevealListener() {
      const db = this.$store.state.db;
      const ref = db.ref(
        "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/revealing"
      );
      const listener = ref.on("value", (snapshot) => {
        const reveal = snapshot.val();
        if (!reveal) return;
        if (reveal.is) {
          // is starting reveal animation
          this.isRevealingCard = true;
          this.selectedCard = reveal.card;
          setTimeout(() => {
            const revealCard = document.getElementById("reveal-card");
            revealCard.style.backgroundColor = this.cardColor(reveal.card);

            if (reveal.card.type === "neutral") {
              revealCard.style.color = "#000";
            }
          }, 1000);

          if (reveal.owner.id === this.player.id) {
            setTimeout(() => {
              this.triggerEndRevealAnimation(reveal.card, reveal.cardIndex);
            }, 4500);
          }
        } else if (!reveal.is) {
          // is ending reveal animation
          this.isRevealingCard = false;
          const revealCard = document.getElementById("reveal-card");
          revealCard.style.backgroundColor = "rgba(0, 0, 0, 1)";
          revealCard.style.color = "#fff";
          if (reveal.card.type === "assassin") {
            if (reveal.owner.id === this.player.id) {
              const losingTeam = this.player.team;
              const db = this.$store.state.db;
              const gameOverQuery =
                "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/isOver";
              const winningTeamQuery =
                "/lobby/" +
                this.lobbyId +
                "/" +
                this.gameId +
                "/state/winningTeam";
              const updates = {};

              updates[winningTeamQuery] = losingTeam === "red" ? "blue" : "red";
              updates[gameOverQuery] = true;
              db.ref().update(updates);
            }
          }
          if (reveal.card.type !== this.currentTurn) {
            this.endTurn();
          }

          if (reveal.owner.id === this.player.id) {
            this.triggerRevealCard(reveal.cardIndex);
          }
        }
      });
      this.listeners.push({
        ref,
        listener,
      });
    },
    initGameStateListener() {
      const db = this.$store.state.db;
      const ref = db.ref(
        "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/cards"
      );
      const listener = ref.on("value", (snapshot) => {
        const cards = snapshot.val();
        this.$store.commit("setCards", cards);
      });
      this.listeners.push({
        ref,
        listener,
      });
      const turnRef = db.ref(
        "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/turn"
      );
      const turnListener = turnRef.on("value", (snapshot) => {
        this.currentTurn = snapshot.val();
      });
      this.listeners.push({
        ref: turnRef,
        listener: turnListener,
      });
      const gameOverRef = db.ref(
        "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/isOver"
      );
      const gameOverListener = gameOverRef.on("value", (snapshot) => {
        this.isGameOver = snapshot.val();
        const winningTeamRef = db.ref(
          "/lobby/" + this.lobbyId + "/" + this.gameId + "/state/winningTeam"
        );
        setTimeout(() => {
          const winnerListener = winningTeamRef.on("value", (snapshot) => {
            this.winningTeam = snapshot.val();
          });
          this.listeners.push({
            ref: winningTeamRef,
            listener: winnerListener,
          });
        }, 2000);
      });
      this.listeners.push({
        ref: gameOverRef,
        listener: gameOverListener,
      });
    },
    initGamePlayersListeners() {
      const db = this.$store.state.db;
      const ref = db.ref(
        "/lobby/" + this.lobbyId + "/" + this.gameId + "/players"
      );
      const listener = ref.on("value", (snapshot) => {
        const players = snapshot.val();

        const dbPlayerIds = [];
        for (const id in players) {
          const player = players[id];
          dbPlayerIds.push(player.id);
        }
        const deadPlayers = this.gamePlayers.filter((x) => {
          return dbPlayerIds.includes(x.id);
        });
        this.$store.commit("removeGamePlayers", deadPlayers);

        for (const id in players) {
          const player = players[id];
          const existingPlayer = this.gamePlayers.find(
            (x) => x.id === player.id
          );
          if (!existingPlayer) {
            this.$store.commit("addGamePlayer", player);
          }
        }
      });
      this.listeners.push({
        ref,
        listener,
      });
    },
    initMyself() {
      const db = this.$store.state.db;
      const query =
        "/lobby/" +
        this.lobbyId +
        "/" +
        this.gameId +
        "/players/" +
        this.player.id;
      const updates = {};
      updates[query] = this.player;
      db.ref().update(updates);
    },
    disconnect() {
      const db = this.$store.state.db;
      if (db) {
        const myPlayerRef = db.ref(
          "/lobby/" +
            this.lobbyId +
            "/" +
            this.gameId +
            "/players/" +
            this.player.id
        );
        myPlayerRef.remove();
      }
    },
  },
  mounted() {    
    this.gameId = this.$store.state.gameId;
    window.z = this
    if (!this.gameId) {
      this.$store.commit("resetState");
      this.$router.push("/");
    }
    this.lobbyId = this.$store.state.lobbyId;
    this.player = this.$store.state.player;
    this.initDbListeners();
    this.initMyself();    
    window.addEventListener("beforeunload", (_e) => {
      this.disconnect();
    });
  },
  beforeDestroy() {
    this.disconnect();
    for (let i = 0; i < this.listeners.length; i++) {
      const listenerObj = this.listeners[i];
      listenerObj.ref.off("value", listenerObj.listener);
    }    
    console.log('before destroy', this.$store.state)
  },
};
</script>

<style scoped lang='sass'>
.game
  background-image: radial-gradient(orange, red, purple)
  width: 100%
  height: 100%
  overflow: scroll
  user-select: none
  position: relative

.reveal  
  background-color: rgba(0, 0, 0, 0.5)
  position: fixed
  width: 100%
  height: 100%
  z-index: 500

#reveal-card
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  width: 300px
  height: 200px
  border: 1px solid #fff  
  display: flex
  background-color: rgba(0, 0, 0, 1)
  justify-content: center
  transition: background 0.5s ease, color 0.5s ease 
  transition-delay: 1s
  align-items: center
  animation-name: shake  
  animation-delay: 0s
  animation-duration: 2s  
  color: #fff
.header
  padding: 40px
  display: flex
  align-items: center
  justify-content: center
  width: 100%
  position: relative
  z-index: 50
  //background-color: rgba(0, 0, 0, 0.5)

.team-turn
  p
    font-size: 32px
    color: red
    text-transform: capitalize

.main-container
  display: flex
  position: relative
  z-index: 50
  width: 100%
  justify-content: center

.red-container
  background-color: rgba(189, 13, 57, 1)
  width: 300px
  min-height: 600px
  display: flex
  flex-direction: column

.blue-container
  background-color: rgba(3, 43, 173, 1)
  width: 300px
  min-height: 600px
  display: flex
  flex-direction: column

.board
  display: flex
  justify-content: center
  max-width: 800px
  margin: 0px auto
  flex-wrap: wrap  

.cell
  user-select: none
  width: 150px
  position: relative
  box-sizing: border-box
  color: #fff
  margin: 5px
  height: 100px
  display: flex
  align-items: center
  justify-content: center
  background-color: rgba(0, 0, 0, 0.5)
  transition: all 0.25s ease-in

.animated:hover  
  transform: translateY(-10px)
  box-shadow: 0px 0px 5px 2px #fff

.team-header
  display: flex
  justify-content: center
  align-items: center
  padding-top: 20px
  p
    color: white
    font-weight: bold
    font-size: 32px

.team-member
  padding: 10px 20px
  text-align: center
  color: #fff
  position: relative
  display: flex
  justify-content: center
  align-items: center

.controls
  width: 100%
  background-color: rgba(0, 0, 0, 0.5)
  display: flex
  justify-content: center
  align-items: center
  transition: background-color 0.2s ease-in
  color: #fff
  box-sizing: border-box
  height: 40px
  border: 1px solid #fff
  cursor: pointer

.vertical-pad
  width: 100%
  flex-grow: 1

.bg-overlay
  position: fixed
  background-color: rgba(0, 0, 0, 0.5)
  z-index: 10
  width: 100%
  height: 100%

@keyframes shake 
  0%
    transform: translate(-50%, -50%) translateX(-10px)
  23%
    transform: translate(-50%, -50%) translateX(10px)
  45%
    transform: translate(-50%, -50%) translateX(-15px)
  55%
    transform: translate(-50%, -50%) translateX(17px)
  65%
    transform: translate(-50%, -50%) translateX(-15px)
  72%
    transform: translate(-50%, -50%) translateX(12px)
  79%
    transform: translate(-50%, -50%) translateX(-15px)
  84%
    transform: translate(-50%, -50%) translateX(15px)
  90%
    transform: translate(-50%, -50%) translateX(-17px)
  92%
    transform: translate(-50%, -50%) translateX(16px)
  95%
    transform: translate(-50%, -50%) translateX(-15px)  
  97%
    transform: translate(-50%, -50%) translateX(16px)
  99%
    transform: translate(-50%, -50%) translateX(-15px)  
  100%
    transform: translate(-50%, -50%) translateX(0px)

.controls:hover
  background-color: rgba(206, 207, 204, 0.7)

.clickable
  cursor: pointer

.spymaster  
  width: 30px
  margin-left: 20px
  img
    width: 100%

.you    
  font-style: italic
  font-family: 'Courier'

.cover  
  position: absolute
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, 0.5)
  z-index: 10

.shine  
  box-shadow: 0px 0px 5px 2px #fff

.typing-demo 
  width: 22ch
  animation: typing 1s
  animation-timing-function: steps(22)
  white-space: nowrap
  overflow: hidden    

@keyframes typing
  0%
    width: 0

.type-blue-team
  width: 9ch
  animation-timing-function: steps(9)  

.type-red-team
  width: 8ch
  animation-timing-function: steps(8)  

.type-play-again  
  width: 10ch
  animation-timing-function: steps(10)    
  font-size: 25px
  font-family: 'Courier'
  padding-top: 20px
  color: white
  font-weight: bold
  cursor: pointer
  transition: transform 0.5s

.type-play-again:hover
  transform: scale(1.2)

.game-over  
  position: fixed
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, 0.7)
  display: flex
  align-items: center
  justify-content: center
  z-index: 1000

.game-over-text 
  display: flex 
  justify-content: center
  align-items: center
  flex-direction: column

.game-over-typing
  font-size: 45px
  font-family: 'Courier'
  color: red
  font-weight: bold
</style>
